import styled from 'styled-components'
import { device } from '../../../theme'

export const AboutServiceWrapStyle = styled.div`
    position: relative;
    z-index: 0;
`;

export const AboutServiceInner = styled.div`
    position: absolute !important;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
`;